import { Suspense, lazy, forwardRef } from 'react';
const LazySurveyJsPollRuntimeContent = lazy(() => import('./SurveyJsPollRuntimeContent'));

const SurveyJsPollRuntime = forwardRef<SurveyJsPollRuntimeRef, SurveyJsPollRuntimeProps>((props, ref) => (
  <Suspense fallback={null}>
    <LazySurveyJsPollRuntimeContent {...props} ref={ref} />
  </Suspense>
));

SurveyJsPollRuntime.displayName = 'SurveyJsPollRuntime';

export type SurveyJsPollRuntimeRef = {
  reset: () => void;
};

type SurveyJsPollRuntimeProps = {
  schema?: { pages: unknown[]; [key: string]: unknown };
  data?: Record<string, unknown>;
  readOnly?: boolean;
  onComplete?: (data: Record<string, unknown>) => void;
};

export default SurveyJsPollRuntime;
